import { Box, Button, Dialog, IconButton, Typography } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import React from 'react';
import { useState } from 'react';

const HomeDialog = () => {
  const [open, setOpen] = useState(true);

  return (
    <Dialog
      open={open}
      disableBackdropClick
      onClose={() => setOpen(false)}
      fullWidth
      maxWidth='md'
    >
      <Box display='flex' width='100%' justifyContent='space-between' my={1}>
        <Box width='10%' />
        <Button
          onClick={() => window.open('https://www.csa2022.com/', '_blank')}
        >
          <Typography variant='h3' color='textPrimary'>
            กดเพื่อเข้าร่วมงาน CSA 2022
          </Typography>
        </Button>
        <IconButton onClick={() => setOpen(false)}>
          <Close />
        </IconButton>
      </Box>
      <Box display='flex' width='100%' justifyContent='center'></Box>
      <img
        src='/images/popup/20220616-popup.jpg'
        width='100%'
        height='100%'
        style={{ cursor: 'pointer' }}
        onClick={() => window.open('https://www.csa2022.com/', '_blank')}
      />
    </Dialog>
  );
};

export default HomeDialog;
